import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { AmenitiesTableAction } from "stores/AmenitiesTableStore/AmenitiesTableAction";

const mapStateToProps = (state) => {
  return {
    AmenitiesTableList: state.amenitiestable.AmenitiesTableList,
    postAmenitiesList: state.amenitiestable.postAmenitiesList,
    isloadingAmenitiesTable: state.amenitiestable.AmenitiesTable,
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getAmenitiesTableAction: AmenitiesTableAction.getAmenitiesTable,
      PostAmenitiesAction: AmenitiesTableAction.PostAmenitiesAction,
      UdateAmenitiesAction: AmenitiesTableAction.UdateAmenitiesAction,
      AmenitiesEnableDisableAction: AmenitiesTableAction.AmenitiesEnableDisable,
    },
    dispatch
  );

const AmenitiesStore = (Container) =>
  connect(mapStateToProps, mapDispatchToProps)(Container);
export default AmenitiesStore;
